// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { QuickstartUiStatus } from '../../../services/constants.tsx';
import type { State } from '../../../services/types.tsx';
import { dispatchEvent } from '../dispatch-event/dispatch-event.tsx';

export const setQuickstartBannerVisibility =
	({ visibility }: { visibility: QuickstartUiStatus }): Action<State> =>
	async ({ getState, setState, dispatch }) => {
		const { visibility: stateVisibility } = getState();

		if (visibility === stateVisibility) {
			return;
		}

		setState({ visibility });
		dispatch(dispatchEvent({ type: 'visibility-change', visibility }));
	};
